import React from 'react';
import { Tag } from 'antd';

import { GroupAcoes } from '../../../components/TableList';

import { MODULE_ROUTE } from './index';

export const templateColumns = ({ onDelete }) => {
  return [
    {
      title: 'Identificador',
      dataIndex: 'identificacao',
      key: 'identificacao',
      align: 'center',
    },
    {
      title: 'Módulo',
      dataIndex: 'modulo',
      key: 'modulo',
      align: 'center',
      responsive: ['sm'],
    },
    {
      title: 'Status',
      key: 'isAtivo',
      dataIndex: 'ativo',
      align: 'center',
      responsive: ['sm'],
      render: isAtivo => (
        <span>
          <Tag color={isAtivo ? 'green' : 'red'}>
            {isAtivo ? 'Ativo' : 'Inativo'}
          </Tag>
        </span>
      ),
    },
    {
      title: 'Ações',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <GroupAcoes
          moduloSistema={MODULE_ROUTE}
          record={record}
          onDelete={onDelete}
        />
      ),
    },
  ];
};
